import React from "react";

import "./FurtherReadingLinks.css";

export const FurtherReadingLinks = ({ children }) => (
  <div className="further-reading-links">{children}</div>
);

export const FurtherReadingLink = ({ href, icon, heading, text }) => (
  <a className="further-reading-link" href={href}>
    <div className="further-reading-link-icon">
      <img src={icon} alt="icon" />
    </div>
    <div className="further-reading-link-right">
      <div className="further-reading-link-heading">{heading}</div>
      <div className="further-reading-link-text">{text}</div>
    </div>
  </a>
);



// WEBPACK FOOTER //
// ./src/components/FurtherReadingLinks.js